import React, {useEffect, useState, useRef} from 'react'
import {Form, Modal} from 'react-bootstrap'
import {
  getDocuments,
  postValidarCelular,
  postValidarCodigo,
  postGenerarCertificado,
  postValidarPassword,
  postGenerarCodigoFirma,
  postVerificarCodigoFirmar,
  rejectSolicitud,
} from '../../Api'
import {Button} from 'react-bootstrap'
import {AlertDialog} from '../../components/Dialog/Dialog'
import {setTitlePage} from '../../Functions'
import ModalSolicitudReject from './components/ModalSolicitudReject'
import {useAuth} from '../../modules/auth'

const Documents = () => {
  const [currentStep, setCurrentStep] = useState('initialStep')
  const [loading, setLoading] = useState(false)
  const [loadingFirma, setLoadingFirma] = useState(false)
  const [phone, setPhone] = useState('')
  const [code, setCode] = useState('')
  const [error, setError] = useState('')
  const [showEnrollment, setShowEnrollment] = useState(false)
  const [showSignatureModal, setShowSignatureModal] = useState(false)
  const [step, setStep] = useState(1)
  const [verificationType, setVerificationType] = useState('')
  const [documentoAFirmar, setDocumentoAFirmar] = useState<Documento | null>(null)
  const [showAlert, setShowAlert] = useState(false)
  const [timeLeft, setTimeLeft] = useState(300) // 300 segundos = 5 minutos
  const timerRef = useRef<number | null>(null) // Referencia para el intervalo
  const [selectedTokens, setSelectedTokens] = useState<string[]>([])
  const [solicitudToReject, setSolicitudToReject] = useState<string | null>(null)
  const [statusRejectSolicitud, setStatusRejectSolicitud] = useState<{
    success?: boolean
    message?: string
  }>({})
  const {currentUser} = useAuth()

  interface UsuarioContraparte {
    rut: string
    nombre: string
    estado_firma: number // 0 = Pendiente, 1 = Firmado
    fecha_firma: string | null
  }

  interface Documento {
    documento_id: number
    titulo: string
    descripcion: string
    ruta_documento: string
    tipo_documento: number
    estado_documento: number
    firmante_id: number
    token: string
    firmante_rut: string
    estado_firma: number // 0 = Pendiente, 1 = Firmado
    fecha_firma: string | null
    fecha_creacion: string | null
    estado_actual: number // 0 = Pendiente de firma, 1 = Esperando firma de contraparte, 2 = Firmado
    certificado_vigente: number // 0 = No vigente, 1 = Vigente
    usuarios_contraparte: UsuarioContraparte[] // Array de usuarios de la contraparte
    rut_solicitud: string
  }
  interface Profesional {
    Telefono_Celular: string
    Email: string
  }
  const [documentosPorFirmar, setDocumentosPorFirmar] = useState<Documento[]>([])
  const [documents, setDocuments] = useState<Documento[]>([])
  const [profesional, setProfesional] = useState<Profesional | null>(null)

  const formatearFecha = (fechaStr: string | null): string => {
    if (!fechaStr) return ''
    const meses = [
      'enero',
      'febrero',
      'marzo',
      'abril',
      'mayo',
      'junio',
      'julio',
      'agosto',
      'septiembre',
      'octubre',
      'noviembre',
      'diciembre',
    ]

    // Suponiendo que el formato de entrada es "DD-MM-YYYY HH:MM"
    const [parteFecha, parteHora] = fechaStr.split(' ')
    const [dia, mes, anio] = parteFecha.split('-')
    // Convertir al formato ISO: "YYYY-MM-DDTHH:MM"
    const fechaISO = `${anio}-${mes}-${dia}${parteHora ? `T${parteHora}` : ''}`

    const fecha = new Date(fechaISO)
    return `${fecha.getDate()} de ${meses[fecha.getMonth()]} de ${fecha.getFullYear()}`
  }

  const formatearFechaHora = (fechaStr: string | null): string => {
    if (!fechaStr) return ''
    const meses = [
      'enero',
      'febrero',
      'marzo',
      'abril',
      'mayo',
      'junio',
      'julio',
      'agosto',
      'septiembre',
      'octubre',
      'noviembre',
      'diciembre',
    ]
    const fecha = new Date(fechaStr.replace(/-/g, '/'))

    const horas = fecha.getHours()
    const minutos = fecha.getMinutes().toString().padStart(2, '0')
    const periodo = horas >= 12 ? 'PM' : 'AM'
    const horas12 = horas % 12 || 12 // Convertir a formato de 12 horas

    return `${fecha.getDate()} de ${
      meses[fecha.getMonth()]
    } de ${fecha.getFullYear()} a las ${horas12}:${minutos} ${periodo}`
  }

  const handlePhoneSubmit = async (e: any) => {
    e.preventDefault()
    setLoadingFirma(true)
    setError('')
    try {
      const _response: any = await postValidarCelular({numero_celular: phone})
      if (_response.status) {
        setCurrentStep('verifyStep')
      } else {
        if (_response?.validations?.errors?.numero_celular) {
          setError(_response.validations.errors.numero_celular[0])
        } else {
          setError(_response.validations.message)
        }
      }
    } catch (err) {
      setError('Error al enviar el código. Por favor intente nuevamente.')
    } finally {
      setLoadingFirma(false)
    }
  }

  const handleCheckboxChange = (event: any) => {
    const {checked, value} = event.target
    if (checked) {
      // Añadir el token al array si está seleccionado
      setSelectedTokens((prevTokens) => [...prevTokens, value])
    } else {
      // Remover el token del array si se desmarca
      setSelectedTokens((prevTokens) => prevTokens.filter((token) => token !== value))
    }
  }

  const startTimer = () => {
    // Limpia cualquier intervalo existente antes de iniciar uno nuevo
    if (timerRef.current !== null) {
      clearInterval(timerRef.current)
    }

    setTimeLeft(300) // Reinicia a 5 minutos

    // Configura el nuevo intervalo
    timerRef.current = window.setInterval(() => {
      setTimeLeft((prevTime) => {
        if (prevTime <= 1) {
          if (timerRef.current !== null) {
            clearInterval(timerRef.current) // Detén el intervalo cuando llegue a 0
          }
          return 0
        }
        return prevTime - 1
      })
    }, 1000)
  }

  const formatTime = (seconds: number) => {
    const minutes = Math.floor(seconds / 60)
    const remainingSeconds = seconds % 60
    return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`
  }

  const validateUserPassword = async () => {
    setLoadingFirma(true)
    setError('')
    try {
      const response: any = await postValidarPassword({passwordUser: password})
      if (response.status) {
        setStep(2)
      } else {
        setError(
          response.validations.message ||
            'Error al validar la contraseña. Por favor intente nuevamente.'
        )
      }
    } catch (err) {
      setError('Error al validar la contraseña. Por favor intente nuevamente.')
    } finally {
      setLoadingFirma(false)
    }
  }

  const generaCodigoFirma = async () => {
    if (verificationType !== 'email' && verificationType !== 'phone') {
      setError('Debe seleccionar un método de verificación')
      return
    }
    setLoadingFirma(true)
    setError('')
    try {
      const response: any = await postGenerarCodigoFirma({
        documento: documentoAFirmar,
        tipo: verificationType,
      })
      if (response.status) {
        setStep(3)
        startTimer()
      } else {
        setError(
          response.validations.message || 'Error al generar código. Por favor intente nuevamente.'
        )
      }
    } catch (err) {
      setError('Error al generar código. Por favor intente nuevamente.')
    } finally {
      setLoadingFirma(false)
    }
  }

  const verifyCodeAndSignDocument = async () => {
    if (!/^\d{6}$/.test(code)) {
      setError('El código debe ser un número de 6 dígitos.')
      return
    }
    setLoadingFirma(true)
    setError('')
    try {
      const response: any = await postVerificarCodigoFirmar({
        documento: documentoAFirmar,
        tipo: verificationType,
        codigo: code,
        selectedTokens: selectedTokens,
      })
      if (response.status) {
        setStep(1)
        setShowSignatureModal(false)
        fetchDocuments()
        setShowAlert(true)
        setSelectedTokens([])
      } else {
        setError(
          response.validations.message ||
            'Error al verificar el código. Por favor intente nuevamente.'
        )
      }
    } catch (err) {
      setError('Error al verificar el código. Por favor intente nuevamente.')
    } finally {
      setLoadingFirma(false)
    }
  }

  const handleDocumentAction = (token: string, action: 'ver' | 'descargar') => {
    if (action === 'ver') {
      window.open(`/documentos/${token}`, '_blank')
      return
    }

    const linkApi = process.env.REACT_APP_API_URL
    window.open(`${linkApi}/documento/${token}/${action}`, '_blank')
  }

  const [activeTab, setActiveTab] = useState('mis-documentos')

  const fetchDocuments = async () => {
    setLoading(true)
    try {
      const _response: any = await getDocuments({})
      if (_response.status) {
        const documentosPendientes = _response.data.documentos.filter(
          (doc: Documento) => Number(doc.estado_documento) === 0
        )
        const documentosFirmados = _response.data.documentos.filter(
          (doc: Documento) => Number(doc.estado_documento) === 1
        )
        if (documentosPendientes.length > 0) {
          setActiveTab('por-firmar')
        } else {
          setActiveTab('mis-documentos')
        }
        setDocumentosPorFirmar(documentosPendientes)
        setDocuments(documentosFirmados)
        setProfesional(_response.data.profesional)
      }
    } catch (err) {
      // setError('Error al obtener los documentos. Por favor intente nuevamente.');
    } finally {
      setLoading(false)
    }
  }

  const toggleEnrollmentModal = () => {
    setShowEnrollment(!showEnrollment)
  }

  const handleCodeVerification = async (e: any) => {
    e.preventDefault()
    setLoadingFirma(true)
    setError('')
    try {
      const _response: any = await postValidarCodigo({codigo: code})
      if (_response.status) {
        setCurrentStep('successStep')
        await handleCertificateGeneration(_response.token)
      } else {
        if (_response?.validations?.errors?.codigo) {
          setError(_response.validations.errors.codigo[0])
        } else {
          setError(_response.validations.message)
        }
      }
    } catch (err) {
      setError('Código inválido. Por favor intente nuevamente.')
    } finally {
      setLoadingFirma(false)
    }
  }

  const handleCertificateGeneration = async (token: string) => {
    setLoadingFirma(true)
    try {
      await new Promise((resolve) => setTimeout(resolve, 2000))
      const _response: any = await postGenerarCertificado({token: token})
      if (_response.status) {
        setCurrentStep('completeStep')
      } else {
        if (_response?.validations?.errors?.codigo) {
          setError(_response.validations.errors.codigo[0])
        } else {
          setError(_response.validations.message)
        }
      }
    } catch (err) {
      setError('Error al generar el certificado. Por favor intente nuevamente.')
    } finally {
      setLoadingFirma(false)
    }
  }

  const renderDoctors = (doctors: UsuarioContraparte[]) => {
    if (!doctors) return null

    const renderStatus = (signed: boolean, fechaFirma: string | null) =>
      signed ? (
        <i className='bi bi-check-circle-fill text-success' title={`Firmado el ${fechaFirma}`}></i>
      ) : (
        <i className='bi bi-clock text-warning' title='Pendiente'></i>
      )

    return (
      <div className='d-flex flex-column gap-2'>
        {doctors.map((doctor, index) => (
          <div key={index} className='d-flex align-items-center gap-2'>
            {renderStatus(
              Number(doctor.estado_firma) === 1,
              formatearFechaHora(doctor.fecha_firma)
            )}
            <span className='text-gray-800'>{doctor.nombre}</span>
          </div>
        ))}
      </div>
    )
  }

  const [password, setPassword] = useState('')

  const handleSubmitPassword = (e: any) => {
    e.preventDefault()
  }

  const handleDocumentSigning = async (doc: Documento) => {
    if (Number(doc.certificado_vigente) === 1) {
      setCode('')
      setPassword('')
      setDocumentoAFirmar(doc)
      if (!selectedTokens.includes(doc.token)) {
        setSelectedTokens((prevTokens) => [...prevTokens, doc.token])
      }
      setShowSignatureModal(true)
      await new Promise((resolve) => setTimeout(resolve, 2000))
    } else {
      toggleEnrollmentModal()
    }
  }

  const groupDocumentsBySolicitud = (docs: any) => {
    return docs.reduce((acc: any, doc: any) => {
      const solicitudId = doc.solicitud_id || 'Sin solicitud'
      if (!acc[solicitudId]) {
        acc[solicitudId] = []
      }
      acc[solicitudId].push(doc)
      return acc
    }, {})
  }

  const handleSelectAllChange = (e: any) => {
    const isChecked = e.target.checked
    if (isChecked) {
      // Selecciona todos los tokens de documentos que se pueden seleccionar
      const tokensToSelect = documentosPorFirmar
        .filter((doc) => Number(doc.estado_actual) === 0)
        .map((doc) => doc.token)
      setSelectedTokens(tokensToSelect)
    } else {
      // Deselecciona todos
      setSelectedTokens([])
    }
  }

  // Función para firmar una solicitud (grupo de documentos)
  const handleSolicitudSigning = async (solicitudId: string, docs: Documento[]) => {
    // Filtrar los documentos que están pendientes de firmar (por ejemplo, estado_actual === 0)
    const tokensSolicitud = docs
      .filter((doc) => Number(doc.estado_actual) === 0)
      .map((doc) => doc.token)

    // Actualizar la selección: deseleccionar otros documentos y seleccionar solo los de la solicitud
    setSelectedTokens(tokensSolicitud)

    // Validar si alguno de los documentos de la solicitud tiene un certificado válido
    const hasValidCertificate = docs.some((doc) => Number(doc.certificado_vigente) === 1)

    if (hasValidCertificate) {
      // Reiniciar valores de código y contraseña
      setCode('')
      setPassword('')
      setShowSignatureModal(true)
      // Esperar 2 segundos (2000ms) antes de continuar
      await new Promise((resolve) => setTimeout(resolve, 2000))
    } else {
      // Si no hay certificado válido, mostrar el modal de inscripción
      toggleEnrollmentModal()
    }
  }
  const handleSolicitudReject = async (solicitudId: string, motivo: string) => {
    try {
      const _response: any = await rejectSolicitud(solicitudId, motivo)
      setSolicitudToReject(null)
      if (_response.status === 200) {
        setStatusRejectSolicitud({success: true, message: 'Solicitud rechazada exitosamente.'})
        fetchDocuments()
      } else {
        setStatusRejectSolicitud({
          success: false,
          message: 'Error al rechazar la solicitud. Por favor intente nuevamente.',
        })
      }
    } catch (err) {
      setStatusRejectSolicitud({
        success: false,
        message: 'Error al rechazar la solicitud. Por favor intente nuevamente.',
      })
    }
  }

  useEffect(() => {
    setTitlePage('Documentos')
    fetchDocuments()
  }, [])
  console.log(currentUser)
  return (
    <>
      <div className='card'>
        <div className='card-header border-0 pt-6'>
          <div className='card-title'>
            <h3 className='fw-bold m-0'>Documentos</h3>
          </div>
        </div>
        <div className='card-body'>
          <ul className='nav nav-tabs nav-line-tabs nav-line-tabs-2x mb-5 fs-6'>
            {documentosPorFirmar.length > 0 && (
              <li className='nav-item'>
                <a
                  className={`nav-link cursor-pointer ${
                    activeTab === 'por-firmar' ? 'active' : ''
                  }`}
                  data-bs-toggle='tab'
                  onClick={() => setActiveTab('por-firmar')}
                  href='#por-firmar'
                >
                  Documentos por firmar
                  <span
                    className='badge badge-light-danger ms-2'
                    style={{border: 'solid 0.5px #f3b1b1'}}
                  >
                    {documentosPorFirmar.length}
                  </span>
                </a>
              </li>
            )}
            {documents.length > 0 && (
              <li className='nav-item'>
                <a
                  className={`nav-link cursor-pointer ${
                    activeTab === 'mis-documentos' ? 'active' : ''
                  }`}
                  data-bs-toggle='tab'
                  onClick={() => setActiveTab('mis-documentos')}
                  href='#mis-documentos'
                >
                  Mis documentos
                </a>
              </li>
            )}
          </ul>

          {selectedTokens.length > 1 && (
            <div className='d-flex justify-content-end mb-4'>
              <button
                type='button'
                className='btn btn-primary'
                onClick={async () => {
                  const hasValidCertificate = documentosPorFirmar.some(
                    (doc) => Number(doc.certificado_vigente) === 1
                  )
                  if (hasValidCertificate) {
                    setCode('')
                    setPassword('')
                    setShowSignatureModal(true)
                    await new Promise((resolve) => setTimeout(resolve, 2000))
                  } else {
                    toggleEnrollmentModal()
                  }
                }}
              >
                Firmar Documentos
              </button>
            </div>
          )}

          {!loading && (
            <div className='tab-content' id='documentTabContent'>
              {/* Tab de documentos por firmar */}
              <div
                className={`tab-pane fade ${
                  activeTab === 'por-firmar' ? 'show active' : ''
                } table-responsive`}
                role='tabpanel'
              >
                <table className='table align-middle table-row-dashed fs-6 gy-5'>
                  <thead>
                    <tr className='text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0'>
                      <th>
                        <input
                          type='checkbox'
                          className='form-check-input'
                          style={{
                            width: '15px',
                            height: '15px',
                            borderRadius: '5px',
                            marginTop: '1px',
                          }}
                          title='Seleccionar todos'
                          onChange={handleSelectAllChange}
                          checked={documentosPorFirmar
                            .filter((doc) => Number(doc.estado_actual) === 0)
                            .every((doc) => selectedTokens.includes(doc.token))}
                        />
                      </th>
                      <th>Documento</th>
                      <th>Fecha</th>
                      <th>Contraparte</th>
                      <th>Estado</th>
                      <th className='text-end'>Acciones</th>
                    </tr>
                  </thead>
                  <tbody className='fw-semibold text-gray-600'>
                    {documentosPorFirmar.length > 0 ? (
                      // Se agrupan los documentos por solicitud_id
                      Object.entries(groupDocumentsBySolicitud(documentosPorFirmar)).map(
                        ([solicitudId, docs]) => (
                          <React.Fragment key={solicitudId}>
                            <tr className='bg-light'>
                              <td colSpan={6}>
                                <div className='d-flex justify-content-between align-items-center'>
                                  <strong className='text-start'>
                                    &nbsp;&nbsp;&nbsp;
                                    {solicitudId === 'Sin solicitud'
                                      ? 'Documentos'
                                      : `Solicitud: ${solicitudId}`}
                                  </strong>
                                  {solicitudId !== 'Sin solicitud' &&
                                    (docs as Documento[]).every(
                                      (doc: Documento) => Number(doc.estado_actual) === 0
                                    ) && (
                                      <div>
                                        {(currentUser?.rut ?? '').split('-')[0].replace(/[.-]/g, '') ===
                                          (docs as Documento[])[0].rut_solicitud && (
                                          <button
                                            type='button'
                                            className='btn btn-sm btn-danger'
                                            onClick={() => setSolicitudToReject(solicitudId)}
                                            style={{marginRight: '10px'}}
                                          >
                                            Rechazar Solicitud
                                          </button>
                                        )}
                                        <button
                                          type='button'
                                          className='btn btn-sm btn-primary'
                                          onClick={() =>
                                            handleSolicitudSigning(solicitudId, docs as Documento[])
                                          }
                                          style={{marginRight: '10px'}}
                                        >
                                          Firmar Solicitud
                                        </button>
                                      </div>
                                    )}
                                </div>
                              </td>
                            </tr>
                            {(docs as Documento[]).map((doc: Documento) => (
                              <tr key={doc.token} className='hover-row'>
                                <td>
                                  <input
                                    type='checkbox'
                                    className='form-check-input'
                                    style={{width: '15px', height: '15px', borderRadius: '5px'}}
                                    disabled={Number(doc.estado_actual) !== 0}
                                    checked={selectedTokens.includes(doc.token)}
                                    value={doc.token}
                                    onChange={(e) => handleCheckboxChange(e)}
                                  />
                                </td>
                                <td>
                                  <div className='d-flex align-items-center'>
                                    <div className='symbol symbol-40px me-4'>
                                      <i className='bi bi-file-pdf fs-2 text-primary'></i>
                                    </div>
                                    <div className='d-flex flex-column'>
                                      <span className='text-gray-800 fw-bold mb-1'>
                                        {doc.titulo}
                                      </span>
                                      <span className='text-gray-600 fs-7'>PDF</span>
                                    </div>
                                  </div>
                                </td>
                                <td>
                                  <div className='d-flex flex-column'>
                                    <span className='text-gray-800'>{doc.fecha_creacion}</span>
                                    <span className='text-gray-600 fs-7'>Fecha creación</span>
                                  </div>
                                </td>
                                <td>{renderDoctors(doc.usuarios_contraparte)}</td>
                                <td>
                                  {Number(doc.estado_actual) === 0 ? (
                                    <span className='badge badge-light-warning'>
                                      Pendiente por firmar
                                    </span>
                                  ) : (
                                    <span className='badge badge-light-info'>
                                      Esperando firma de contraparte
                                    </span>
                                  )}
                                </td>
                                <td className='text-end'>
                                  <button
                                    type='button'
                                    className='btn btn-sm btn-icon btn-light me-2'
                                    onClick={() => handleDocumentAction(doc.token, 'ver')}
                                    data-bs-toggle='tooltip'
                                    title='Ver documento'
                                  >
                                    <i className='bi bi-eye'></i>
                                  </button>
                                  <button
                                    type='button'
                                    className='btn btn-sm btn-icon btn-light-primary me-2'
                                    onClick={() => handleDocumentAction(doc.token, 'descargar')}
                                    data-bs-toggle='tooltip'
                                    title='Descargar documento'
                                  >
                                    <i className='bi bi-download'></i>
                                  </button>
                                  {/* Si el documento pertenece a 'Sin solicitud', se muestra el botón de firma individual */}
                                  {Number(doc.estado_actual) === 0 &&
                                    solicitudId === 'Sin solicitud' && (
                                      <button
                                        type='button'
                                        className='btn btn-sm btn-primary'
                                        onClick={() => handleDocumentSigning(doc)}
                                      >
                                        <i className='bi bi-pen me-2'></i>
                                        Firmar
                                      </button>
                                    )}
                                </td>
                              </tr>
                            ))}
                          </React.Fragment>
                        )
                      )
                    ) : (
                      <tr>
                        <td colSpan={6} className='text-center p-20'>
                          <div className='text-gray-600 text-center'>
                            <span className='svg-icon svg-icon-5x opacity-50 mb-5 d-block'>
                              <i className='bi bi-file-text fs-3x'></i>
                            </span>
                            <span className='fs-6 fw-semibold'>
                              No tienes documentos por firmar
                            </span>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {/* Tab de mis documentos */}
              <div
                className={`tab-pane fade ${activeTab === 'mis-documentos' ? 'show active' : ''}`}
                role='tabpanel'
              >
                {documents.length > 0 ? (
                  // Agrupamos también por solicitud_id
                  Object.entries(groupDocumentsBySolicitud(documents)).map(
                    ([solicitudId, docs]) => (
                      <React.Fragment key={solicitudId}>
                        <div className='p-4 bg-light'>
                          <h5> Solicitud: {solicitudId}</h5>
                        </div>
                        {(docs as Documento[]).map((doc: Documento) => (
                          <div
                            key={doc.documento_id}
                            className='d-flex flex-stack py-4 px-6 border-bottom hover-border-primary'
                          >
                            <div className='d-flex align-items-center'>
                              <div className='symbol symbol-40px me-4'>
                                <i className='bi bi-file-pdf fs-2 text-primary'></i>
                              </div>
                              <div>
                                <div className='text-gray-800 fw-semibold'>
                                  {formatearFecha(doc.fecha_creacion)}
                                </div>
                                <div className='fs-5 fw-bold mb-1'>{doc.titulo}</div>
                                <div className='text-gray-600 fs-7'>Documento PDF</div>
                              </div>
                            </div>
                            <div className='d-flex justify-content-end'>
                              <button
                                className='btn btn-sm btn-light me-2'
                                onClick={() => handleDocumentAction(doc.token, 'ver')}
                              >
                                <i className='bi bi-eye me-2'></i>
                                Ver
                              </button>
                              <button
                                className='btn btn-sm btn-light-primary'
                                onClick={() => handleDocumentAction(doc.token, 'descargar')}
                              >
                                <i className='bi bi-download me-2'></i>
                                Descargar
                              </button>
                            </div>
                          </div>
                        ))}
                      </React.Fragment>
                    )
                  )
                ) : (
                  <div className='text-center p-20'>
                    <div className='text-gray-600 text-center'>
                      <span className='svg-icon svg-icon-5x opacity-50 mb-5 d-block'>
                        <i className='bi bi-file-text fs-3x'></i>
                      </span>
                      <span className='fs-6 fw-semibold'>No tienes documentos</span>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
          {loading && (
            <div className='text-center py-10'>
              <div className='spinner-border text-primary'></div>
            </div>
          )}
        </div>
      </div>
      <Modal show={showEnrollment} size='lg' onHide={() => setShowEnrollment(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Enrolamiento para Firma Digital</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Header */}
          <div className='text-center mb-8'>
            <p className='text-gray-600'>
              Complete este proceso para poder firmar documentos digitalmente
            </p>
          </div>

          {/* Error Alert */}
          {error && (
            <div className='alert alert-danger d-flex align-items-center mb-5'>
              <i className='fas fa-exclamation-circle fs-4 me-2'></i>
              <div>{error}</div>
              <button type='button' className='btn-close' onClick={() => setError('')}></button>
            </div>
          )}

          {/* Initial Step */}
          {currentStep === 'initialStep' && (
            <form onSubmit={handlePhoneSubmit}>
              <div className='mb-5'>
                <label className='form-label'>Confirme su número de teléfono</label>
                <p className='text-gray-600 fs-7'>
                  Su número registrado termina en:{' '}
                  <strong>****{profesional?.Telefono_Celular}</strong>
                </p>
                <input
                  type='tel'
                  className='form-control form-control-lg'
                  placeholder='+56 9 XXXX XXXX'
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  required
                />
                <div className='form-text'>Recibirá un código de verificación por SMS</div>
              </div>
              <div className='d-grid gap-2'>
                <button type='submit' className='btn btn-primary btn-lg' disabled={loadingFirma}>
                  {loadingFirma && <span className='spinner-border spinner-border-sm me-2'></span>}
                  Enviar código
                </button>
              </div>
            </form>
          )}

          {/* Verification Step */}
          {currentStep === 'verifyStep' && (
            <form onSubmit={handleCodeVerification}>
              <div className='mb-5'>
                <label className='form-label'>Código de verificación</label>
                <input
                  type='text'
                  className='form-control form-control-lg'
                  placeholder='Ingrese el código de 6 dígitos'
                  value={code}
                  onChange={(e) => setCode(e.target.value)}
                  required
                />
                <div className='form-text'>Ingrese el código enviado al número {phone}</div>
              </div>
              <div className='d-grid gap-2'>
                <button type='submit' className='btn btn-primary btn-lg' disabled={loadingFirma}>
                  {loadingFirma && <span className='spinner-border spinner-border-sm me-2'></span>}
                  Verificar código
                </button>
              </div>
            </form>
          )}

          {/* Success Step */}
          {currentStep === 'successStep' && (
            <div className='text-center'>
              <i className='fas fa-check-circle text-success fs-1 mb-5'></i>
              <h3 className='fw-bolder mb-2'>Verificación exitosa</h3>
              <p className='text-gray-600 mb-8'>
                Su número de teléfono ha sido verificado. Ahora generaremos su certificado digital.
              </p>
              <div className='d-grid gap-2'>
                <button className='btn btn-success btn-lg' disabled={loadingFirma}>
                  {loadingFirma && <span className='spinner-border spinner-border-sm me-2'></span>}
                  Generando certificado
                </button>
              </div>
            </div>
          )}

          {/* Complete Step */}
          {currentStep === 'completeStep' && (
            <div className='text-center'>
              <i className='fas fa-check-circle text-success fs-1 mb-5'></i>
              <h3 className='fw-bolder mb-2'>¡Proceso completado!</h3>
              <p className='text-gray-600 mb-8'>
                Su certificado digital ha sido generado exitosamente. Ya puede proceder a firmar
                documentos.
              </p>
              <div className='d-grid gap-2'>
                <button
                  className='btn btn-primary btn-lg'
                  onClick={() => {
                    setShowEnrollment(false)
                    fetchDocuments()
                    setCurrentStep('initialStep')
                  }}
                >
                  Comenzar a firmar
                </button>
              </div>
            </div>
          )}

          {/* Support Information */}
          <div className='mt-8 pt-6 border-top'>
            <p className='text-gray-600 fs-7 mb-0'>
              <i className='fas fa-info-circle me-1'></i>
              Si sus datos de contacto no son correctos o necesita actualizar su información, por
              favor comuníquese con nuestro equipo de soporte a
              <a href='mailto:informaciones@amsm.cl' className='ms-1'>
                informaciones@amsm.cl
              </a>{' '}
              para recibir asistencia personalizada.
            </p>
          </div>
        </Modal.Body>
      </Modal>
      <Modal show={showSignatureModal} onHide={() => setShowSignatureModal(false)} size='lg'>
        <Modal.Header closeButton>
          <Modal.Title>
            {step === 1 ? 'Verificación de identidad' : 'Ingrese el código de verificación'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Error Alert */}
          {error && (
            <div className='alert alert-danger d-flex align-items-center mb-5'>
              <i className='fas fa-exclamation-circle fs-4 me-2'></i>
              <div>{error}</div>
              <button type='button' className='btn-close' onClick={() => setError('')}></button>
            </div>
          )}
          {step === 1 && (
            <div className='card card-custom'>
              {/* Metronic card styling */}
              <div className='card-body p-9'>
                <Form onSubmit={handleSubmitPassword}>
                  {/* Alert using Metronic styles */}
                  <div className='notice d-flex bg-light-primary rounded border-primary border border-dashed mb-9 p-6'>
                    <div className='d-flex flex-stack flex-grow-1'>
                      <div className='fw-semibold'>
                        <h4 className='text-gray-900 fw-bold'>Importante</h4>
                        <div className='fs-6 text-gray-700'>
                          Antes de firmar el documento, debes revisar el borrador y verificar que
                          los datos ingresados son correctos, ya que una vez firmado el documento
                          tiene validez legal.
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className='text-center mb-5'>
                    <p className='text-gray-700 fs-6 fw-semibold'>
                      Para continuar debes ingresar tu contraseña de usuario
                    </p>
                  </div>

                  {/* Password input with Metronic styling */}
                  <div className='mb-10 fv-row'>
                    <Form.Control
                      type='password'
                      className='form-control form-control-lg form-control-solid text-center'
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      placeholder='••••••••'
                      required
                    />
                  </div>
                </Form>
              </div>
            </div>
          )}
          {step === 2 && (
            <>
              <p>Seleccione dónde desea recibir el código de verificación:</p>
              <div
                className={`p-3 mb-3 border rounded ${
                  verificationType === 'email' ? 'bg-light-primary' : ''
                }`}
                onClick={() => setVerificationType('email')}
                style={{cursor: 'pointer'}}
              >
                <i className='bi bi-envelope me-2'></i>
                Correo electrónico
                <div className='text-muted'>{profesional?.Email}</div>
              </div>
              <div
                className={`p-3 mb-3 border rounded ${
                  verificationType === 'phone' ? 'bg-light-primary' : ''
                }`}
                onClick={() => setVerificationType('phone')}
                style={{cursor: 'pointer'}}
              >
                <i className='bi bi-phone me-2'></i>
                Teléfono móvil
                <div className='text-muted'>*****{profesional?.Telefono_Celular}</div>
              </div>
            </>
          )}
          {step === 3 && (
            <div className='text-center'>
              <p>
                Hemos enviado un código de verificación a su{' '}
                {verificationType === 'phone' ? 'teléfono' : 'correo'}
              </p>
              <input
                type='text'
                className='form-control text-center mb-3'
                maxLength={6}
                placeholder='• • • • • •'
                value={code}
                onChange={(e) => setCode(e.target.value)}
              />
              <div className='text-muted mb-3'>El código expirará en: {formatTime(timeLeft)} </div>
              <a
                href='#'
                onClick={(e) => {
                  e.preventDefault()
                  if (timeLeft === 0) {
                    setStep(2)
                  }
                }}
                className={`${timeLeft > 0 ? 'opacity-50 pointer-events-none' : 'text-primary'}`}
              >
                Reenviar código
              </a>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant='secondary'
            onClick={() => {
              setShowSignatureModal(false)
              setStep(1)
            }}
          >
            Cancelar
          </Button>

          {step === 1 && (
            <Button
              variant='primary'
              onClick={() => validateUserPassword()}
              disabled={loadingFirma}
            >
              {loadingFirma && <span className='spinner-border spinner-border-sm ms-2'></span>}{' '}
              Continuar
            </Button>
          )}

          {step === 2 && (
            <Button variant='primary' onClick={() => generaCodigoFirma()} disabled={loadingFirma}>
              {loadingFirma && <span className='spinner-border spinner-border-sm ms-2'></span>}{' '}
              Enviar código
            </Button>
          )}

          {step === 3 && (
            <Button
              variant='primary'
              onClick={() => verifyCodeAndSignDocument()}
              disabled={loadingFirma}
            >
              {loadingFirma && <span className='spinner-border spinner-border-sm ms-2'></span>}{' '}
              Verificar y firmar
            </Button>
          )}
        </Modal.Footer>
      </Modal>
      <AlertDialog
        message='Documento firmado exitosamente'
        show={showAlert}
        success={true}
        onConfirm={() => {
          setShowAlert(false)
        }}
      />
      <ModalSolicitudReject
        show={solicitudToReject !== null}
        onCancel={() => setSolicitudToReject(null)}
        onConfirm={async (motivo) => {
          handleSolicitudReject(solicitudToReject!, motivo)
        }}
      />

      <AlertDialog
        message={statusRejectSolicitud.message}
        show={!!statusRejectSolicitud.message}
        success={statusRejectSolicitud.success}
        onConfirm={() => {
          setStatusRejectSolicitud({})
        }}
      />
    </>
  )
}

export default Documents
